'use strict';

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result['default'] = mod;
  return result;
};

Object.defineProperty(exports, '__esModule', {
  value: true
});

var react_1 = __importStar(require('react'));

var sizeSpec = {
  XXS: 10,
  XS: 12,
  S: 16,
  M: 18,
  L: 20,
  XL: 24,
  XXL: 32,
  '3XL': 36,
  '4XL': 42,
  '5XL': 48,
  '6XL': 52,
  '7XL': 58,
  '8XL': 64,
  '9XL': 70
};

var Title =
/** @class */
function (_super) {
  __extends(Title, _super);

  function Title() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};
    return _this;
  }

  Title.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        className = _a.className,
        subTitle = _a.subTitle,
        children = _a.children;
    var fontSize = size && (typeof size === 'string' ? sizeSpec[size] : size);
    return react_1.default.createElement('div', {
      className: 'padding-vertical-normal light fg-primary ' + (className || ''),
      style: {
        fontSize: fontSize
      }
    }, children, react_1.default.createElement('sub', {
      className: 'gerami-title-subtitle fg-blackish'
    }, subTitle));
  };

  return Title;
}(react_1.Component);

exports.Title = Title;